import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import { App } from './App';

/**
 * opus-ia App entry point.
 *
 * Renders the root App component inside StrictMode.
 * App provides: QueryClient, ThemeProvider, and Router.
 */

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
